import { ChangeEvent, useState } from 'react';
import { useRouter } from 'next/router';
import { useGetSupplementProductsShapes } from '@api/supplement/supplementApis.rq';
import { TextInput } from '@com/_atoms/NewTextInput';
import { Radio } from '@com/_atoms/Radio';
import {
  pickApiQuery,
  SUPPLEMENT_FILTER_API_KEYS,
} from '@utilities/catalog/apiQuery';

type Shapes = {
  shapeName?: string;
  shapeCode?: string;
};

const shimerData = ['1', '2', '3', '4', '5'];

type ShapesFilterProps = {
  plpQuery?: any;
  onSelectShape: (item: Shapes) => void;
  categoryCodeLevel1?: string;
  categoryCodeLevel2?: string;
  categoryCodeLevel3?: string;
};

const ShapesFilter = ({
  plpQuery,
  onSelectShape,
  categoryCodeLevel1,
  categoryCodeLevel2,
  categoryCodeLevel3,
}: ShapesFilterProps) => {
  const { query } = useRouter();
  const { data: shapesData, isLoading: shapesIsLoading } =
    useGetSupplementProductsShapes(
      pickApiQuery(
        query,
        { categoryCodeLevel1, categoryCodeLevel2, categoryCodeLevel3 },
        { allowKeys: SUPPLEMENT_FILTER_API_KEYS },
      ),
    );

  const [selectedShape, setSelectedShape] = useState<Shapes>(
    plpQuery?.shapeCode
      ? { shapeName: plpQuery?.shapeName, shapeCode: plpQuery?.shapeCode }
      : null,
  );
  const [filteredShapes, setFilteredShapes] = useState<Shapes[] | null>(null);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event?.target?.value) {
      setFilteredShapes(shapesData);
    } else {
      const filteredItems = shapesData?.filter((item) =>
        item?.shapeName
          ?.toLowerCase()
          ?.includes(event?.target?.value?.toLowerCase()),
      );
      setFilteredShapes(filteredItems);
    }
  };

  const handleSelectShape = (item: Shapes) => {
    if (item?.shapeCode !== selectedShape?.shapeCode) {
      setSelectedShape(item);
      onSelectShape(item);
    }
  };

  const renderShimer = () => {
    return (
      <>
        {shimerData.map((item) => (
          <div key={item} className="h-[52px] flex flex-col">
            <div className="h-[51.5px] flex items-center gap-8">
              <div className="w-6 h-6 bg-surface-tertiary rounded-full animate-pulse" />
              <div className="w-20 h-3 bg-surface-tertiary rounded-full animate-pulse" />
            </div>
            <div className="w-[calc(100%-21px)] h-[0.5px] bg-border-primary mr-[42px]" />
          </div>
        ))}
      </>
    );
  };

  const renderShapesContent = () => {
    if (shapesIsLoading) {
      return renderShimer();
    }

    if (!!filteredShapes?.length) {
      return (
        <>
          {filteredShapes?.map((item) => (
            <div key={item?.shapeCode} className="h-[52px] flex flex-col">
              <div className="h-[51.5px] flex items-center">
                <Radio
                  label={item?.shapeName}
                  checked={selectedShape?.shapeName === item?.shapeName}
                  handleChange={() => handleSelectShape(item)}
                />
              </div>
              <div className="w-[calc(100%-21px)] h-[0.5px] bg-border-primary mr-[42px]" />
            </div>
          ))}
        </>
      );
    }

    return (
      <>
        {!!shapesData.length &&
          shapesData?.map((item) => (
            <div key={item?.shapeCode} className="h-[52px] flex flex-col">
              <div className="h-[51.5px] flex items-center">
                <Radio
                  label={item?.shapeName}
                  checked={selectedShape?.shapeName === item?.shapeName}
                  handleChange={() => handleSelectShape(item)}
                />
              </div>
              <div className="w-[calc(100%-21px)] h-[0.5px] bg-border-primary mr-[42px]" />
            </div>
          ))}
      </>
    );
  };

  return (
    <div className="flex flex-col gap-2 py-4">
      <TextInput
        placeholder="جستجو"
        onChange={handleSearch}
        id="search"
        name="firstName"
      />

      <div className="h-[300px] overflow-y-scroll overflow-x-hidden">
        {renderShapesContent()}
      </div>
    </div>
  );
};
export default ShapesFilter;
